import { render, staticRenderFns } from "./BannerArmy.vue?vue&type=template&id=4d5612ce&scoped=true"
import script from "./BannerArmy.vue?vue&type=script&lang=js"
export * from "./BannerArmy.vue?vue&type=script&lang=js"
import style0 from "./BannerArmy.vue?vue&type=style&index=0&id=4d5612ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5612ce",
  null
  
)

export default component.exports